module.exports = __webpack_public_path__ + "static/img/profile.0337b191.png";